import { agencyLaunchpadRoutes } from '@/routes/constants/agency'
import { SideBarItemConfig } from '../baseSideBarItemConfig'

const i18nConfigText = 'common.sidebar.agencyLaunchpad'

const launchpadConfig: SideBarItemConfig = {
  name: i18nConfigText,
  enabled: true,
  items: [],
  type: 'header',
  meta: 'agency-launchpad',
  tooltip: i18nConfigText,
  permissions: {
    all: [],
    any: [],
  },
  icon: 'https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_launchpad.svg',
  children: [],
  route: {
    name: agencyLaunchpadRoutes.default,
    params: [],
  },
  userScopes: {
    any: [],
    all: ['agency/launchpad.write'],
  },
}

export default launchpadConfig